import React from "react";

import ContentLogin from "./ContentLogin";

const Login = () => {
  return (
    <>
      <ContentLogin />
    </>
  );
};

export default Login;
